import { __ } from '@wordpress/i18n';
import { TextControl, Button } from '@wordpress/components';

const HeaderContact = ({ attributes, setAttributes, section, index }) => {
    const {
        style,
        dataByStyle,
    } = attributes || {};

    const currentData = dataByStyle[style] || {};
	const updateField = (field, value) => {
		setAttributes({
			dataByStyle: {
				...dataByStyle,
				[style]: {
					...currentData,
					[field]: value,
				},
			},
		});
	};
    return (
        <>
            <div className="bwdcv-contact-info-wrap">
                <>
                    <div className="phone-number-wrap">
                        <TextControl
                            label={__('Phone Number', 'cv-builder')}
                            value={currentData.phoneNumber}
					        onChange={(value) => updateField('phoneNumber', value)}
                            placeholder='+65 7657 4218'
                        />
                    </div>
                    <div className="email-wrap">
                        <TextControl
                            label={__('Email', 'cv-builder')}
                            value={currentData.email}
                            onChange={(value) => updateField('email', value)}
                            placeholder='H4QG4@example.com'
                        />
                    </div>
                </>
                <div className="address-wrap">
                    <TextControl
                        label={__('Address', 'cv-builder')}
                        value={currentData.address}
                        onChange={(value) => updateField('address', value)}
                        placeholder='New York, USA'
                    />
                </div>
                <div className="city-wrap">
                    <TextControl
                        label={__('City', 'cv-builder')}
                        value={currentData.city}
                        onChange={(value) => updateField('city', value)}
                        placeholder='New York'
                    />

                </div>
                <div className="postal-code-wrap">
                    <TextControl
                        label={__('Postal Code', 'cv-builder')}
                        value={currentData.postalCode}
                        onChange={(value) => updateField('postalCode', value)}
                        placeholder='10001'
                    />

                </div>
                <div className="website-wrap">
                    <TextControl
                        label={__('Website', 'cv-builder')}
                        value={currentData.website}
                        onChange={(value) => updateField('website', value)}
                        placeholder='example.com'
                    />
                </div>
            </div>
        </>
    );
}

export default HeaderContact